import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TableContainer,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { CardBase } from '@/src/components/organisms';

import SectionDynamic from './SectionDynamic';

export default function ComparativeTable(props) {
  const {
    className,
    section,
    title,
    headerFeature,
    headerItem1,
    headerItem2,
    rows,
    refElem,
    ...rest
  } = props;
  const theme = useTheme();

  return (
    <SectionDynamic type={section}>
      <div className={className} ref={refElem} {...rest}>
        <CardBase withShadow liftUp>
          <Typography
            variant="h4"
            color="textPrimary"
            align="left"
            mb={4}
            sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
          <TableContainer
            sx={{
              border: `1px solid ${theme.palette.primary.light}`,
              borderRadius: theme.spacing(0.5),
            }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: theme.palette.primary.light }}>
                  <TableCell>
                    <Typography variant="h6" color="white">
                      {headerFeature}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" color="white" fontWeight="bold">
                      {headerItem1}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" color="white">
                      {headerItem2}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((row, index) => (
                  <TableRow
                    key={`${row.table_cell_feature}${index.toString()}`}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover },
                    }}>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary" fontWeight="bold">
                        {row.table_cell_feature}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="textPrimary">
                        {row.table_cell_item_1}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="GrayText">
                        {row.table_cell_item_2}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardBase>
      </div>
    </SectionDynamic>
  );
}

ComparativeTable.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  headerFeature: PropTypes.string,
  headerItem1: PropTypes.string,
  headerItem2: PropTypes.string,
  rows: PropTypes.array,
  refElem: PropTypes.any,
};
